import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import { BaseAutoTracker } from '../../auto/BaseAutoTracker';
import type { TrackerFactory } from '../../tracks/TrackerFactory';

const CHECKOUT_SELECTORS = [
  'form[action*="checkout"]',
  '[data-checkout]',
  '[name="checkout"]',
  'button[name="checkout"]',
  'a[href*="checkout"]',
];

export class CheckoutDetector extends BaseAutoTracker {
  readonly name = 'CheckoutDetector';
  private readonly factory: TrackerFactory;

  constructor(context: PixelRuntimeContext, factory: TrackerFactory) {
    super(context);
    this.factory = factory;
  }

  protected onInit(): void {
    if (!this.isDocumentAvailable()) return;
    this.addDocumentListener('click', event => this.handleClick(event), true);
    this.addDocumentListener('submit', event => this.handleSubmit(event), true);
  }

  protected onDestroy(): void {}

  private handleClick(event: Event): void {
    const element =
      event.target instanceof Element
        ? event.target.closest('a,button,[role="button"],input[type="submit"]')
        : null;

    if (!element) return;

    const text = element.textContent?.toLowerCase() ?? '';
    const href = (element as HTMLAnchorElement).href?.toLowerCase() ?? '';

    const isCheckout =
      CHECKOUT_SELECTORS.some(selector => element.matches(selector)) ||
      (text.includes('checkout') && !text.includes('continue shopping')) ||
      (text.includes('finalizar') && text.includes('compra')) ||
      href.includes('/checkout');

    if (isCheckout) {
      this.factory.trackAuto(
        'INITIATE_CHECKOUT',
        {},
        {
          origin: 'auto:checkout',
        }
      );
    }
  }

  private handleSubmit(event: Event): void {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;

    const action = form.getAttribute('action')?.toLowerCase() ?? '';
    if (action.includes('checkout') || form.matches('[data-checkout]')) {
      this.factory.trackAuto(
        'INITIATE_CHECKOUT',
        {},
        {
          origin: 'auto:checkout',
        }
      );
    }
  }
}
